import {
    liveStoryFragment,
    liveStoryUpdateFragment,
    associatedContentFragment,
} from "../fragments/liveStory";
import { getFeedCookie } from "../../../utils/cookies/library";

export const liveStoryContentItem = (sourceId, isPreview, pubDate) => {
    let contentStatus = "";
    if (isPreview) {
        const nine_gtoken = getFeedCookie("nine_gtoken");
        contentStatus = `preview;aggToken=${
            nine_gtoken?.value
        };cacheBust=${Date.now()}`;
    }
    const subQueryArgs = queryArgsToString({ pageSize: 10 });
    const sharedUpdateArgs = getSharedUpdateArgs(pubDate);
    return `
        query {
            liveStoryPage:contentItem(sourceId: "${sourceId}", contentStatus: "${contentStatus}") {
                ...liveStoryFragment
                liveStory {
                    eventTitle
                    updates(${subQueryArgs}) {
                        nodes {
                            ...liveStoryUpdateFragment
                        }
                    }
                    ${
                        sharedUpdateArgs
                            ? `sharedUpdate: updates(${sharedUpdateArgs}) {
                        nodes {
                            ...liveStoryUpdateFragment
                        }
                    }`
                            : ""
                    }
                }
            }
        }
        ${liveStoryFragment}
        ${liveStoryUpdateFragment}
        ${associatedContentFragment}
    `;
};

export const liveStoryUpdates = (sourceId, queryArgs) => {
    const subQueryArgs = queryArgsToString(queryArgs);
    return `
        query {
            liveStoryUpdates:contentItem(sourceId: "${sourceId}") {
                ...liveStoryFragment
                liveStory {
                    eventTitle
                    updates(${subQueryArgs}) {
                        nodes {
                            ...liveStoryUpdateFragment
                        }
                    }
                }
            }
        }
        ${liveStoryFragment}
        ${liveStoryUpdateFragment}
        ${associatedContentFragment}
    `;
};

const queryArgsToString = ({
    minPubDate,
    maxPubDate,
    pageSize,
    sort = "-publishedAt",
} = {}) => {
    const args = [];

    minPubDate && args.push(`minPubDate: "${minPubDate}"`);
    maxPubDate && args.push(`maxPubDate: "${maxPubDate}"`);
    pageSize && args.push(`pageSize: ${pageSize}`);
    sort && args.push(`sort: "${sort}"`);

    return args.join(", ");
};

const getSharedUpdateArgs = (pubDate) => {
    const validPubDate = validateTimestampFormat(pubDate) ? pubDate : null;
    return validPubDate
        ? queryArgsToString({
              minPubDate: validPubDate,
              maxPubDate: validPubDate,
          })
        : null;
};

const validateTimestampFormat = (timestamp) => {
    const regex = /^\d+$/;
    return typeof timestamp === "string" && regex.test(timestamp);
};
